/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getActorLikes.defs.js'
export { main as default } from './getActorLikes.defs.js'
